<img [src]="src" alt="Image" (load)="onImageLoad()" [ngClass]="imageClass" [hidden]="!isLoaded" />